import { Button, Modal } from 'rsuite';
import styles from './DownloadProcessingModal.module.scss';

export type DownloadProcessingModalProps = {
  show: boolean;
  onHide: () => void;
};

const MailClockIcon = () => (
  <svg
    viewBox="0 0 48 48"
    width="56"
    height="56"
    fill="none"
    stroke="currentColor"
    strokeWidth="3"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M29 35H10a3 3 0 0 1-3-3V14a3 3 0 0 1 3-3h28a3 3 0 0 1 3 3v9" />
    <path d="M7 14l17 11 17-11" />
    <circle cx="36" cy="34" r="8" fill="var(--white, #fff)" />
    <path d="M36 30v4.5l3 2" />
  </svg>
);

export const DownloadProcessingModal = ({ show, onHide }: DownloadProcessingModalProps) => (
  <Modal show={show} onHide={onHide} className={styles.modal} size="sm">
    <Modal.Header className={styles.header} />
    <Modal.Body>
      <div className={styles.iconWrap} role="img" aria-label="e-mail em processamento">
        <MailClockIcon />
      </div>
      <h3 className={styles.title}>Estamos processando sua extração</h3>
      <p className={styles.description}>
        Sua extração é grande demais para ser baixada na hora, por isso vamos processá-la e avisar por e-mail assim que o arquivo estiver pronto para download.
        Você pode fechar esta janela: o processamento continua em segundo plano.
      </p>
    </Modal.Body>
    <Modal.Footer className={styles.footer}>
      <Button appearance="primary" onClick={onHide} className={styles.closeButton}>
        Fechar
      </Button>
    </Modal.Footer>
  </Modal>
);
